import { render, staticRenderFns } from "./editzfForm.vue?vue&type=template&id=1cf778da&scoped=true&"
import script from "./editzfForm.vue?vue&type=script&lang=js&"
export * from "./editzfForm.vue?vue&type=script&lang=js&"
import style0 from "./editzfForm.vue?vue&type=style&index=0&lang=css&"
import style1 from "./editzfForm.vue?vue&type=style&index=1&id=1cf778da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf778da",
  null
  
)

component.options.__file = "editzfForm.vue"
export default component.exports